import { useEffect } from 'react'
import { RootState } from '../store/modules/rootReducer'
import { getSubscriptionsOnce } from '../store/modules/subscription/actions'
import TrackingMiddleware from '../tracking'

import TagManager from 'react-gtm-module'
import { toast } from 'react-toastify'

import queryString from 'query-string'

import { signInSuccess, signOut } from '../store/modules/auth/actions'
import { getLearningCoursesOnce } from '../store/modules/learningCourses/action'
import { learningApi } from './api'
import { useDispatch, useSelector } from 'react-redux'
import history from './history'
import { Dispatch } from 'redux'
import posthog from 'posthog-js'
import { setFeatureFlags } from '../store/modules/posthog/action'
import { TFeatureFlags, TFlagsPayload } from '../store/modules/posthog/types'

export const StartupLogic = () => {
  const dispatch = useDispatch()
  const { auth } = useSelector((state: RootState) => ({
    auth: state.auth,
    student: state.student,
  }))

  useEffect(() => {
    if (!auth.token) return

    InitialApiFetch(dispatch)
  }, [auth.token, dispatch])

  useEffect(() => {
    InitPosthog(dispatch)
    InitTagManager()
    QueryStringLogin(dispatch)
  }, [dispatch])

  return null
}

function InitialApiFetch(dispatch: Dispatch<any>) {
  dispatch(getSubscriptionsOnce())
  dispatch(getLearningCoursesOnce())
}

async function QueryStringLogin(dispatch: Dispatch<any>) {
  try {
    const query = queryString.parse(window.location.search) || {}

    if (query.auth) {
      dispatch(signOut())

      const { data } = await learningApi.get('/student/auth', {
        headers: {
          Authorization: `Bearer ${query.auth}`,
        },
      })

      const { student, subscription, preference, refresh_token } = data

      localStorage.setItem('token', query.auth as string)

      dispatch(
        signInSuccess({
          token: query.auth as string,
          refresh_token,
          profile: {
            ...student,
            subscription,
            preference: preference[0]?.objectType,
          },
        })
      )
    }

    if (query.operatorToken) {
      const { data } = await learningApi.post('/student/auth', {
        operatorToken: query.operatorToken,
      })

      const { student, subscription, preference, token, refresh_token } = data

      localStorage.setItem('token', token)

      dispatch(
        signInSuccess({
          token,
          refresh_token,
          profile: {
            ...student,
            subscription,
            preference: preference[0]?.objectType,
          },
        })
      )
    }

    if (query.title) {
      history.push(`/my-profile?title=${query.title}`)
    }

    if (query.course) {
      history.push(
        `/course/${query.course}/module/${query.module}/lesson/${query.lesson}/chapter/${query.chapter}?type=${query.type}`
      )
    }
  } catch (error) {
    return toast.error('Não foi possível realizar o login')
  }
}

function InitPosthog(dispatch: Dispatch<any>) {
  if (process.env.REACT_APP_POSTHOG_API_KEY) {
    TrackingMiddleware.initPosthog(process.env.REACT_APP_POSTHOG_API_KEY)
    posthog.onFeatureFlags((flags) => {
      const payloads = {}

      flags.forEach((flag) => {
        Object.assign(payloads, { [flag]: posthog.getFeatureFlagPayload(flag) })
      })

      dispatch(
        setFeatureFlags({ flags: flags as TFeatureFlags[], payloads: payloads as TFlagsPayload })
      )
    })
  }
}

function InitTagManager() {
  if (process.env.REACT_APP_GTM_KEY) {
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GTM_KEY,
    }

    TagManager.initialize(tagManagerArgs)
  }
}
